import { Modal, Table, Image, Tag } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeNoResultsModal } from "../../store/reducer/googleSearch";

// Maps the backend's per-item `status` to a readable label/color for the table.
// Falls back to a generic "error" styling for anything unrecognized, so a future
// status the backend adds doesn't silently render blank.
const STATUS_META = {
   no_match: { label: "No Match Found", color: "orange" },
   no_value: { label: "Not Enough Data", color: "gold" },
   error: { label: "Search Error", color: "red" },
};

const NoResultsModal = () => {
   const dispatch = useDispatch();
   // The store registers this reducer under "googleSearch" (see store.js), not the
   // "google" namespace the slice's own (unused, mismatched) googleSearchSelector reads from.
   const { showNoResultsModal, noResultItems } = useSelector(state => state.googleSearch);

   const columns = [
      {
         title: "Image",
         dataIndex: "image_url",
         key: "image_url",
         width: 90,
         render: imageUrl => (
            <Image
               src={imageUrl}
               width={60}
               height={60}
               style={{ objectFit: "cover", borderRadius: 4 }}
               fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII="
            />
         ),
      },
      {
         title: "Item",
         dataIndex: "item_name",
         key: "item_name",
         render: name => name || <span className="text-muted">Unknown item</span>,
      },
      {
         title: "Status",
         dataIndex: "status",
         key: "status",
         width: 150,
         render: status => {
            const meta = STATUS_META[status] || STATUS_META.error;
            return <Tag color={meta.color}>{meta.label}</Tag>;
         },
      },
      {
         title: "Reason",
         dataIndex: "reason",
         key: "reason",
         render: (reason, record) => reason || record.error || record.message || "Unknown reason",
      },
   ];

   return (
      <Modal
         title={`${noResultItems.length} item${noResultItems.length === 1 ? "" : "s"} could not be valued`}
         open={showNoResultsModal}
         onCancel={() => dispatch(closeNoResultsModal())}
         onOk={() => dispatch(closeNoResultsModal())}
         cancelButtonProps={{ style: { display: "none" } }}
         okText="Close"
         width={720}
      >
         <Table
            columns={columns}
            dataSource={noResultItems.map((item, index) => ({ ...item, key: item.item_id ?? index }))}
            pagination={{ pageSize: 5 }}
            size="small"
         />
      </Modal>
   );
};

export default NoResultsModal;
